// import { Outlet } from "react-router-dom";
// import Navbar from "./Navbar";
// import Footer from "./Footer";

// const Layout = () => (
//   <div className="min-h-screen flex flex-col grid-pattern">
//     <Navbar />
//     <main className="flex-1">
//       <Outlet />
//     </main>
//     <Footer />
//   </div>
// );

// export default Layout;

import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();

  // Additional safety scroll to top
  useEffect(() => {
    // Force scroll to top on every route change
    const scrollToTop = () => {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
      document.body.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    };
    
    scrollToTop();
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col grid-pattern">
      <Navbar />
      <main className="flex-1 pt-0"> {/* Removed any padding-top that might cause issues */}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;